import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import TextField from '@mui/material/TextField';
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
// Material Dashboard 2 React example components
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "layouts/Tables/DataTable";
import Config from "../../config.js";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { CircularProgress, Backdrop } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FormControl } from '@mui/material';
import MDButton from "components/MDButton";
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { handleErrors, checkPrivilege } from "common.js";
import { PRIVILEGE, CUSTOM_FIELD } from "constants.js";

function ManageCustomField(props) {
  const navigate = useNavigate();
  const [type, setType] = useState(props.props.type);
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [customFieldData, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [categoryId, setCategory] = useState(0);
  const [fieldOrder, setFieldOrder] = useState({});
  const [categoryTree, setCategoryHierarchy] = useState({});
  const adminType = localStorage.getItem("type");

  const findCustomFieldType = (cType) => {
    return (cType == CUSTOM_FIELD.TEXT) ? t('text') : (cType == CUSTOM_FIELD.DROPDOWN) ? t('dropdown') : (cType == CUSTOM_FIELD.NUMERIC) ? t('numeric') : (cType == CUSTOM_FIELD.DATE) ? t('date') : (cType == CUSTOM_FIELD.TEXTAREA) ? t('textarea') : (cType == CUSTOM_FIELD.MULTISELECT) ? t('multiselect') : (cType == CUSTOM_FIELD.FILE) ? t('file') : null;
  }

  const convertToTree = (data) => {
    const treeData = [];
    let tempArrayNew = {};
    tempArrayNew.label = t('general');
    tempArrayNew.value = 0;
    tempArrayNew.checked = true;
    treeData.push(tempArrayNew);
    data.forEach((node) => {
      if (node) {
        let tempArrayNew = {};
        tempArrayNew.label = node.name;
        tempArrayNew.value = node.id;
        treeData.push(tempArrayNew);
      }
    });
    return treeData;
  };

  const changeStatus = async (id) => {
    setIsLoading(true)
    axios({
      url: BASE + "api/custom/remove/" + id + '/' + props.props.type,
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false)
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          const updatedRows = customFieldData.data.rows.filter((row) => row.id !== id);
          setData({
            ...data,
            data: {
              ...data.data,
              rows: updatedRows
            }
          });
          toast.success(t(message));
        }
        else {
          if (message != '')
            toast.error(t(message))
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch((error) => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  const getHierarchy = () => {
    setIsLoading(true);
    axios({
      url: BASE + "api/category/getHierarchy/" + props.props.type,
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false)
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          const convertedData = convertToTree(response.data.data);
          setCategoryHierarchy(convertedData);
        }
        else {
          if (message != '')
            toast.error(t(message))
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch((error) => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  const data = () => {

    axios({
      // Endpoint to send files
      url: BASE + "api/custom/list",
      method: "POST",
      data: { categoryId: categoryId, type: props.props.type },
      headers: {
        // Add any auth token here
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false)
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setFieldOrder((pre) => {
            const productInfo = response.data.data.rows;
            const tempArray = [];
            let i = 0;
            productInfo.forEach(element => {
              let newId = element.id;
              let newPosition = element.position;
              let customObject = { id: newId, position: newPosition };
              tempArray.push(customObject);
            });
            return (tempArray);
          })
          setData(response.data);
        }
        else {
          if (message != '')
            toast.error(t(message))
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  useEffect(() => {
    data();
    if (props.props.type != CUSTOM_FIELD.VENDOR)
      getHierarchy();
  }, [props]);

  useEffect(() => {
  }, [fieldOrder]);

  const setCategoryData = (currentNode, selectedNodes) => {
    setCategoryHierarchy((pre) => {
      let preData = pre;
      let selectedCategory = selectedNodes[0].value;
      setCategory(selectedNodes[0].value);
      preData.forEach((item, index) => {
        if (item.value === selectedCategory) {
          // Update the value for the matching row
          preData[index].checked = selectedNodes[0].checked;
          preData[index].hide = selectedNodes[0].hide;
          preData[index]._focused = selectedNodes[0]._focused;
          preData[index]._depth = selectedNodes[0]._depth;
          preData[index]._id = selectedNodes[0]._id;
        }
        else {
          preData[index].checked = false;
          preData[index]._focused = false;
        }
      });
      return preData;
    });
  };

  const handleFieldOrderChange = (event, id) => {
    const { value } = event.target;
    setFieldOrder(prevData => {
      // Find the index of the object with the matching ID
      const index = prevData.findIndex(item => item.id === id);
      if (index !== -1) {
        const newData = [...prevData];
        newData[index] = { ...newData[index], position: value };
        return newData;
      }
      return prevData;
    });
  };

  const getPositionById = (id, fieldOrder) => {
    const foundObject = fieldOrder.find(item => item.id === id);
    return foundObject ? foundObject.position : null; // Return the position if ID is found, otherwise return null
  };

  const validatePosition = () => {
    const positionsSet = new Set();
    for (const item of fieldOrder) {
      if (positionsSet.has(item.position)) {
        return true; // Duplicate position found
      }
      positionsSet.add(parseInt(item.position));
    }
    return false; // No duplicate positions found
  }

  const updatePosition = () => {
    setIsLoading(true)
    if (validatePosition() == false) {
      axios({
        url: BASE + "api/custom/sorting",
        method: "POST",
        data: { type: props.props.type, sortedCustoms: JSON.stringify(fieldOrder), categoryId: categoryId },
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          function: Config.FUNCTION_KEY
        },
        // Attaching the form data
      }).then(function (response) {
        setIsLoading(false);
        if (response.status == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            toast.success(t(message));
          }
          else {
            if (message != '')
              toast.error(t(message))
          }
        }
        else {
          toast.error(t('unableToProccessRequest'));
        }
      }).catch((error) => {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
    }
    else {
      toast.error(t('duplicate position found'));
    }
  }

  const columns = [{ Header: t("id"), accessor: "id", align: "left" }];
  if (props.props.type === 1 || props.props.type === 2) {
    columns.push({ Header: t("category"), accessor: "categoryId", align: "left" });
  }
  columns.push({ Header: t("fieldType"), accessor: "fieldType", align: "left" });
  columns.push({ Header: t("fieldName"), accessor: "fieldName", align: "left" });
  columns.push({ Header: t("displayName"), accessor: "displayName", align: "left" });
  columns.push({ Header: t("mandatory"), accessor: "mandatory", align: "left" });
  columns.push({ Header: t("showOnShop"), accessor: "showOnShop", align: "left" });
  columns.push({ Header: t("position"), accessor: "position", align: "left" });
  columns.push({ Header: t("action"), accessor: "action", align: "left" });

  const finalObj = [];

  for (let key in customFieldData.data) {
    if (key == 'rows') {
      customFieldData.data[key].map(function (val, index) {
        let serviceType = (props.props.type == CUSTOM_FIELD.PRODUCT) ? 'productCustomfield' : (props.props.type == CUSTOM_FIELD.SERVICE) ? 'serviceCustomfield' : (props.props.type == CUSTOM_FIELD.VENDOR) ? 'vendorCustomfield' : null;
        let tempObj = {
          id: "#" + val.id, categoryId: (val.categoryId == 0) ? t('general') : (props.props.type == CUSTOM_FIELD.VENDOR) ? t('na') : val.categoryName, fieldType: findCustomFieldType(val.fieldType),
          fieldName: val.fieldName, displayName: val.displayName,
          mandatory: (val.mandatory == 0) ? t('no') : t('yes'), showOnShop: (val.showOnShop == 0) ? t('no') : t('yes'),
          position: <TextField
            onChange={(event) => handleFieldOrderChange(event, val.id)}
            value={getPositionById(val.id, fieldOrder)} inputProps={{ type: 'number', className: "formOrder" }} />,
          action:
            <span className="actionLinksStyle">
              {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("customfield", "read") || checkPrivilege("customfield", "write")))) ?
                <MDTypography component="a" href={'#'} onClick={(event) => { event.preventDefault(); navigate("/" + serviceType + "/edit/" + val.id + '/' + type) }} variant="caption" color="text" fontWeight="medium">
                  <Tooltip title={t('Edit')} className="paddingRight5"><Box className="ActionEdit"><EditIcon /></Box></Tooltip>
                </MDTypography>
                : null}
              {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && (checkPrivilege("customfield", "delete")))) ?
                <MDTypography component="a" onClick={() => changeStatus(val.id)}>
                  <span className="generalFont"><Tooltip title={t('Delete')} className="paddingRight5"><Box className="ActionDelete"><DeleteIcon /></Box></Tooltip></span>
                </MDTypography>
                :
                null}
            </span>
        };
        finalObj.push(tempObj);
      })

      let tempObj = {
        id: "", categoryId: "", fieldType: "",
        fieldName: "", displayName: "",
        mandatory: "", showOnShop: "",
        position: (adminType == PRIVILEGE.SUBADMIN) ? checkPrivilege("customfield", "write") ? <Button className="SubmitButton" onClick={updatePosition}>{t('update')}</Button> : null : <Button className="SubmitButton" onClick={updatePosition}>{t('update')}</Button>,
        action: ""
      };

      if (finalObj.length > 0) {
        finalObj.push(tempObj)
      }
    }
  }

  const rows = finalObj;

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={(props.props.type == CUSTOM_FIELD.PRODUCT) ? t('productCustomFields') : (props.props.type == CUSTOM_FIELD.SERVICE) ? t('serviceCustomFields') : (props.props.type == CUSTOM_FIELD.VENDOR) ? t('vendorCustomFields') : null} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
      {(Object.keys(customFieldData).length > 0) ?
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                {(props.props.type != CUSTOM_FIELD.VENDOR) ?
                  <MDBox className="ManageVendorsTopSec" mx={2}
                    mt={0}
                    py={3}
                    px={2}
                    variant="gradient">
                    <Grid container className="FilterSectionBox" spacing={2} style={{ "border": "1px solid #DDDDDD", "paddingBottom": "10px", "background": "#f7f7f7" }}>
                      <Grid item xs={12} sm={4} md={4} >
                        {(categoryTree) ?
                          (
                            <DropdownTreeSelect
                              data={categoryTree}
                              mode="radioSelect"
                              texts={{ placeholder: t('select category') }}
                              onChange={setCategoryData}
                            />
                          )
                          : null}
                      </Grid>
                      <Grid item xs={12} sm={1} md={1}>
                        <FormControl>
                          <MDButton onClick={() => { data() }} key="submit" type="submit" color="info" className="SubmitButton" size="small" disableRipple fullWidth>{t('go')}</MDButton>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </MDBox>
                  : null}
                <MDBox mx={2} mt={0} py={3} px={2} variant="gradient">
                </MDBox>
                <MDBox pt={0}>
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={{ defaultValue: 100 }}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        :
        null
      }
    </DashboardLayout>
  );
}

export default ManageCustomField;
